// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form__group {
    position: relative;
    padding: 15px 0 0;
    margin-top: 10px;
    width: 100%;
  }
  
  .form__field {
    font-family: inherit;
    width: 100%;
    border: 0;
    border-bottom: 1px solid #fff;
    outline: 0;
    font-size: 15px;
    color: #fff;
    padding: 7px 0;
    background: transparent;
    transition: border-color 0.2s;
  }
  .form__field::placeholder {
    color: transparent;
  }
  .form__field:placeholder-shown ~ .form__label {
    font-size: 1rem;
    cursor: text;
    top: 20px;
  }
  
  .form__label {
    position: absolute;
    top: -8px;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #fff;
  }
  
  .form__field:focus {
    padding-bottom: 6px;
    font-weight: 700;
    border-width: 3px;
    border-image: linear-gradient(to right, #9b9b9b, #9b9b9b);
    border-image-slice: 1;
  }
  .form__field:focus ~ .form__label {
    position: absolute;
    top: -8px;
    display: block;
    transition: 0.2s;
    font-size: 1rem;
    color: #9b9b9b;
    font-weight: 700;
  }
  
  /* reset input */
  .form__field:required, .form__field:invalid {
    box-shadow: none;
  }
  .color_button{
      background-color: #000;
      color:#fff;
      border: 1px solid!important;
  }
  .child_class{
    /* box-shadow: 0 4px 8px 0 #212529, 0 6px 20px 0 #212529; */
    border-radius: 10px;
  }
  @media only screen and (min-width:500px){
  .child_class{
    position: relative;
    width: 40%;
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    color:#fff
  }
}
@media only screen and (max-width:499px){
  .child_class{
    position: relative;
    /* width: 50%; */
    left: 50%;
    top:50%;
    transform: translate(-50%,-50%);
    color:#fff
  }
}
  
  /* demo */`, "",{"version":3,"sources":["webpack://./src/CSS/Signup.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,SAAS;IACT,6BAA6B;IAC7B,UAAU;IACV,eAAe;IACf,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yDAAyD;IACzD,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;EAClB;EACA;MACI,sBAAsB;MACtB,UAAU;MACV,2BAA2B;EAC/B;EACA;IACE,2DAA2D;IAC3D,mBAAmB;EACrB;EACA;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,OAAO;IACP,+BAA+B;IAC/B;EACF;AACF;AACA;EACE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,OAAO;IACP,+BAA+B;IAC/B;EACF;AACF;;EAEE,SAAS","sourcesContent":[".form__group {\n    position: relative;\n    padding: 15px 0 0;\n    margin-top: 10px;\n    width: 100%;\n  }\n  \n  .form__field {\n    font-family: inherit;\n    width: 100%;\n    border: 0;\n    border-bottom: 1px solid #fff;\n    outline: 0;\n    font-size: 15px;\n    color: #fff;\n    padding: 7px 0;\n    background: transparent;\n    transition: border-color 0.2s;\n  }\n  .form__field::placeholder {\n    color: transparent;\n  }\n  .form__field:placeholder-shown ~ .form__label {\n    font-size: 1rem;\n    cursor: text;\n    top: 20px;\n  }\n  \n  .form__label {\n    position: absolute;\n    top: -8px;\n    display: block;\n    transition: 0.2s;\n    font-size: 1rem;\n    color: #fff;\n  }\n  \n  .form__field:focus {\n    padding-bottom: 6px;\n    font-weight: 700;\n    border-width: 3px;\n    border-image: linear-gradient(to right, #9b9b9b, #9b9b9b);\n    border-image-slice: 1;\n  }\n  .form__field:focus ~ .form__label {\n    position: absolute;\n    top: -8px;\n    display: block;\n    transition: 0.2s;\n    font-size: 1rem;\n    color: #9b9b9b;\n    font-weight: 700;\n  }\n  \n  /* reset input */\n  .form__field:required, .form__field:invalid {\n    box-shadow: none;\n  }\n  .color_button{\n      background-color: #000;\n      color:#fff;\n      border: 1px solid!important;\n  }\n  .child_class{\n    /* box-shadow: 0 4px 8px 0 #212529, 0 6px 20px 0 #212529; */\n    border-radius: 10px;\n  }\n  @media only screen and (min-width:500px){\n  .child_class{\n    position: relative;\n    width: 40%;\n    left: 50%;\n    top:50%;\n    transform: translate(-50%,-50%);\n    color:#fff\n  }\n}\n@media only screen and (max-width:499px){\n  .child_class{\n    position: relative;\n    /* width: 50%; */\n    left: 50%;\n    top:50%;\n    transform: translate(-50%,-50%);\n    color:#fff\n  }\n}\n  \n  /* demo */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
